import { useTranslation } from 'next-i18next'

export default function EmployeeEducationalDegree({
  educationalDegree,
}: {
  educationalDegree?: string
}): React.ReactElement {
  const { t } = useTranslation('ourTeam')

  return (
    <div className="mt-1 text-center">
      <div className="font-semibold text-black-light" data-testid="degree-text">
        {t('degree')}
      </div>
      <div className="text-black-light" data-testid="tutors-educational-degree">
        {educationalDegree}
      </div>
    </div>
  )
}
